// import KReactive from '../../utils/KReactive'
// import KDom from '../../utils/KDom'
import Vue from 'vue'
// import $ from 'jquery'
// import { window, document } from 'ssr-window'

// let hasEvents = false
// let eventTarget = null
// let supportsPassiveEvent = false
// const KFocused = new KReactive({
//   // 全局维护一个当前 Focus 的元素
//   currentElement: null,
// })

// 全局维护一个当前 Focus 的元素
const KFocused = new Vue({
  data() {
    return {
      currentElement: null,
    }
  },
})

// function checkPassiveEventSupport() {
//   try {
//     const opts = Object.defineProperty({}, 'passive', {
//       get() {
//         supportsPassiveEvent = { passive: true }
//       },
//     })
//     window.addEventListener('ghost', null, opts)
//   } catch (e) {}
// }

// function setKeyboardInteraction({ target }) {
//   KFocused.currentElement = target
// }

// function setMouseAndTouchInteraction(event) {
//   KFocused.currentElement = KDom.closest(event.target, '[tabindex]')
// }

// function createKeyboardEvents() {
//   eventTarget.addEventListener('keyup', setKeyboardInteraction)
// }

// // 有关 pointer 的介绍：
// // https://segmentfault.com/a/1190000004077840
// function createPointerEvents() {
//   eventTarget.addEventListener('pointerup', setMouseAndTouchInteraction)
// }

// function createMSPointerEvents() {
//   eventTarget.addEventListener('MSPointerUp', setMouseAndTouchInteraction)
// }

// function createMouseAndTouchEvents() {
//   eventTarget.addEventListener('mouseup', setMouseAndTouchInteraction)

//   if ('ontouchend' in window) {
//     eventTarget.addEventListener('touchend', setMouseAndTouchInteraction, supportsPassiveEvent)
//   }
// }

// function bindEvents() {
//   if (window.PointerEvent) {
//     createPointerEvents()
//   } else if (window.MSPointerEvent) {
//     createMSPointerEvents()
//   } else {
//     createMouseAndTouchEvents()
//   }

//   createKeyboardEvents()
// }

// function createEvents() {
//   if (!hasEvents) {
//     eventTarget = document.body
//     checkPassiveEventSupport()
//     bindEvents()
//     hasEvents = true
//   }
// }

export default {
  data: () => ({
    kHasFocus: false,
  }),
  computed: {
    focusedElement() {
      return KFocused.currentElement
    },
  },
  watch: {
    focusedElement(el) {
      this.kHasFocus = el === this.$el
    },
  },
  mounted() {
    // createEvents()
  },
  beforeDestroy() {
    if (KFocused.currentElement === this.$el) {
      KFocused.currentElement = null
    }
  },
}
